import { Alert, Button } from 'flowbite-react'
import { FC, useEffect, useState } from 'react'
import {
    externalBrowserInstructions,
    inAppBrowserLabel,
    isInAppBrowser,
    openInExternalBrowser,
} from '@/shared/inAppBrowser'

const InAppBrowserBanner: FC = () => {
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        setVisible(isInAppBrowser())
    }, [])

    if (!visible) return null

    return (
        <div className="sticky top-0 z-50 border-b border-amber-200 bg-amber-50 px-3 py-3 shadow-sm">
            <Alert color="warning" className="mb-0 border-amber-300 bg-amber-50">
                <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                    <div className="text-sm text-amber-900">
                        <p className="font-semibold">
                            Para comprar com segurança, abra no Chrome ou Safari
                        </p>
                        <p className="mt-1 text-amber-800">
                            Você está no navegador do {inAppBrowserLabel()}. Pagamentos podem falhar aqui.
                        </p>
                        <p className="mt-1 text-xs text-amber-700">{externalBrowserInstructions()}</p>
                    </div>
                    <Button
                        size="sm"
                        color="warning"
                        className="shrink-0 whitespace-nowrap"
                        onClick={() => openInExternalBrowser()}
                    >
                        Abrir no navegador
                    </Button>
                </div>
            </Alert>
        </div>
    )
}

export default InAppBrowserBanner
